export default __webpack_public_path__ + "static/media/Copy of 15-An-Apple-A-Day.1a3d6ca0.jpg";